
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M34.837 1a8.972 8.972 0 016.364 2.636A8.972 8.972 0 0143.837 10h0v24.837a8.972 8.972 0 01-2.636 6.364 8.972 8.972 0 01-6.364 2.636h0H10a8.972 8.972 0 01-6.364-2.636A8.972 8.972 0 011 34.837h0V10a8.972 8.972 0 012.636-6.364A8.972 8.972 0 0110 1h0z","stroke":"#504F4F","stroke-width":"2"}}),_c('path',{attrs:{"d":"M21.12 17.417a5.876 5.876 0 014.144.923 5.853 5.853 0 012.434 3.472h0v.019a4.691 4.691 0 013.305 5.023 4.695 4.695 0 01-4.365 4.142.487.487 0 01-.128 0h0-15.281a4.202 4.202 0 01-4.223-3.97 4.198 4.198 0 013.772-4.399 4.57 4.57 0 012.55-3.218 4.593 4.593 0 014.11.119 5.865 5.865 0 013.681-2.111zm1.87 1.165a4.77 4.77 0 00-4.92 1.963.56.56 0 01-.783.146 3.478 3.478 0 00-3.476-.348 3.463 3.463 0 00-2.021 2.84.546.546 0 01-.558.492h0-.043a3.111 3.111 0 00-3.102 3.12 3.11 3.11 0 003.128 3.093h0v.002h15.27l-.001.017a3.602 3.602 0 003.425-3.278 3.599 3.599 0 00-2.802-3.823.549.549 0 01-.421-.439 4.758 4.758 0 00-3.696-3.785zm4.135-3.89a4.75 4.75 0 014.688-1.574 4.73 4.73 0 013.539 3.446h0v-.018a3.824 3.824 0 012.62 4.098 3.829 3.829 0 01-3.532 3.35.578.578 0 01-.121 0h0-1.612a.55.55 0 110-1.097h1.604a2.73 2.73 0 002.597-2.485 2.73 2.73 0 00-2.123-2.898.556.556 0 01-.422-.441 3.633 3.633 0 00-2.846-2.917 3.64 3.64 0 00-3.772 1.553.547.547 0 01-.366.234.537.537 0 01-.418-.091 2.628 2.628 0 00-3.434.328.552.552 0 01-.779.02.547.547 0 01-.02-.777 3.73 3.73 0 014.397-.73z","stroke":"#BF9C5F","stroke-width":".2","fill":"#BF9C5F","fill-rule":"nonzero"}})])])
          )
        }
      }
    